export default async () => {
	// planning

	// remove ssr planning
	await window.appInitializer.initClubAdvantagesApp();

	// function initPlanning(){
	//   const planningRoot = document.querySelector('#planner-app');
	//   if (planningRoot && elementInViewport(planningRoot)) {
	//     window.appInitializer.initPlanningApp()
	//       window.removeEventListener('scroll', initPlanning)
	//     }
	// }

	// window.addEventListener('scroll', initPlanning)
};
